import { Badge, Tooltip } from '@mantine/core';
import { Activity } from 'lucide-react';

export function WebSocketStatus() {
  return (
    <Tooltip label="Auto-refreshing">
      <Badge
        color="green"
        variant="dot"
        size="xl"
        leftSection={<Activity size={16} />}
        style={{
          paddingLeft: 12,
          paddingRight: 16,
          minWidth: 100,
          display: 'inline-flex',
          alignItems: 'center',
          whiteSpace: 'nowrap'
        }}
      >
        Live
      </Badge>
    </Tooltip>
  );
}
